<h1>Domain Flags Management</h1>
<p>Manage domain flags, view domains with specific flags, and perform flag operations.</p>

@if (isAdminPlus()) {
    <div class="button_row">
        <button mat-raised-button color="primary"
                [disabled]="isBusy()"
                (click)="addFlag()">+ Add Flag</button>
    </div>
}

@if (flags()) {
    <table mat-table id="flags_table" [dataSource]="flags()">
        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Flag</th>
            <td mat-cell *matCellDef="let flag">{{flag.name}}</td>
        </ng-container>

        <ng-container matColumnDef="preventsDelete">
            <th mat-header-cell *matHeaderCellDef>Prevents Delete</th>
            <td mat-cell *matCellDef="let flag" [innerHTML]="flag.preventsDelete? '&check;' : ''"></td>
        </ng-container>

        <ng-container matColumnDef="domainCount">
            <th mat-header-cell *matHeaderCellDef>Domains</th>
            <td mat-cell
                *matCellDef="let flag"
                [class]="{link: flag.domainCount>0}"
                matTooltip="Show/hide list of domains with this flag"
                matTooltipPosition="after"
                [matTooltipDisabled]="flag.domainCount==0"
                (click)="flag.domainCount>0? loadDomains(flag.name, true) : null"
            >{{flag.domainCount}}</td>
        </ng-container>

        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>Actions</th>
            <td mat-cell *matCellDef="let flag">
                <button mat-icon-button
                        matTooltip="Modify flag"
                        color="primary"
                        [disabled]="!isAdminPlus()"
                        (click)="modifyFlag(flag)">
                    <mat-icon>edit</mat-icon>
                </button>
                <button mat-icon-button
                        matTooltip="Delete flag"
                        [color]="flag.domainCount>0? 'warn' : 'primary'"
                        [disabled]="!isAdminPlus()"
                        (click)="maybeDeleteFlag(flag)">
                    <mat-icon>delete</mat-icon>
                </button>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="flagColumnsToDisplay"></tr>
        <tr mat-row
            *matRowDef="let flag; columns: flagColumnsToDisplay"></tr>

    </table>
}

@if (totalDomains() > 0) {
    <div class="paginator_row">
        <span class="table_title">Domains with assigned to flag: {{selectedFlag()}}</span>
        <mat-paginator #paginator
                       [length]="totalDomains()"
                       [showFirstLastButtons]="true"
                       [pageIndex]="currentPage()"
                       [pageSize]="pageSize()"
                       [pageSizeOptions]="PAGE_SIZE_OPTIONS"
                       (page)="onPageChange($event)"></mat-paginator>
    </div>
    <div class="table_scroller">
        <table mat-table id="domains_table" [dataSource]="flagDomainsDataSource()">
            <ng-container matColumnDef="domain">
                <th mat-header-cell *matHeaderCellDef>Domain</th>
                <td mat-cell *matCellDef="let domain">{{domain.name}}</td>
            </ng-container>
            <ng-container matColumnDef="assigned">
                <th mat-header-cell *matHeaderCellDef>Assigned</th>
                <td mat-cell *matCellDef="let domain">{{formatTimestamp(domain.assigned)}}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="domainColumnsToDisplay"></tr>
            <tr mat-row *matRowDef="let row; columns: domainColumnsToDisplay"></tr>
        </table>
    </div>
}
